import { FormGroup } from '@angular/forms';

export class Operation {
  id: string;
  name: string;
  sector: string;
  workersCount: number;
  workersCountPermanent: number;
  workersCountSeasonal: number;
  quantity: number;
  time: number;
  ordinal: number;
  plannedTime: number;
  timePlannedEmployee: number;
  timeDelegatedEmployee: number;
  timeCorrectionEmployee: number;
  timeEstimatedEmployee: number;
  timeEstimatedEmployeePermanent: number;
  timeEstimatedEmployeeSeasonal: number;
  timeEstimatedMachine: number;
  timeCorrectionMachine: number;
  quantityFinished: number;
  quantityCorrection: number;
  dates: Array<any>;
  comment: string;
  isAdditional: boolean;
  machineId: string;
  machineName: string;
  workOrderId: string;
  workOrderName: string;
  workOrderUpisId: string;
  client: string;
  isSelected: boolean;
  timeConsumedEmployeeTotal: number;
  quantityFinishedTotal: number;
  quantityToPlan: number;
  quantityPlanned: number;
  deviationFromPlan: boolean;
  shifts: Array<any>;
  workOrderClient: string;
  upisId: string;
  operationName: string;
  timeConsumedEmployee: number;
  worksheetComments: Array<string>;
  productionTaskId: string;
  workOrderOperationName: string;
  deliveryDeadline: string;
  quantityDelegated: number;
  isButtonVisible: boolean;
  form: FormGroup;
  isExpanded: boolean;
  isFinished: boolean;
  isPriority: boolean;
  isExternalOperation: boolean;
  operationSupplier: string;
  requiredMainTime: string;
  requiredAditionalTime: number;
  isAdded: boolean;
  productName: string;
  estimatedCountSesonalWorkersDaily: number;
  timePlannedMachine: number;
  timeConsumedMachine: number;

  constructor(operation) {
    this.id = operation.id || operation.workOrderOperationId || operation.workOrderUpisId || operation.workRequestOperationId || undefined;
    this.name = operation.name || operation.workOrderOperationName || undefined;
    this.sector = operation.sector || undefined;
    this.workersCount = operation.workersCount ?? undefined;
    this.workersCountPermanent = operation.workersCountPermanent ?? undefined;
    this.workersCountSeasonal = operation.workersCountSeasonal ?? 0;
    this.quantity = operation.quantity || 0;
    this.time = operation.time || undefined;
    this.ordinal = operation.ordinal || undefined;
    this.plannedTime = operation.plannedTime || undefined;
    this.timePlannedEmployee = operation.timePlannedEmployee || 0;
    this.timeDelegatedEmployee = operation.timeDelegatedEmployee || 0;
    this.timeCorrectionEmployee = operation.timeCorrectionEmployee || 0;
    this.timeEstimatedEmployee = operation.timeEstimatedEmployee || 0;
    this.timeEstimatedEmployeePermanent = operation.timeEstimatedEmployeePermanent || 0;
    this.timeEstimatedEmployeeSeasonal = operation.timeEstimatedEmployeeSeasonal || 0;
    this.timeConsumedEmployeeTotal = operation.timeConsumedEmployeeTotal || 0;
    this.timeEstimatedMachine = operation.timeEstimatedMachine || 0;
    this.timeCorrectionMachine = operation.timeCorrectionMachine || 0;
    this.quantityFinished = operation.quantityFinished || 0;
    this.quantityFinishedTotal = operation.quantityFinishedTotal || 0;
    this.quantityToPlan = operation.quantityToPlan || 0;
    this.quantityPlanned = operation.quantityPlanned || 0;
    this.quantityCorrection = operation.quantityCorrection || 0;
    this.deviationFromPlan = operation.deviationFromPlan || undefined;
    this.dates = operation.dates || undefined;
    this.comment = operation.comment || undefined;
    this.isAdditional = operation.isAdditional || undefined;
    this.machineId = operation.machineId || undefined;
    this.machineName = operation.machineName || undefined;
    this.workOrderName = operation.workOrderName || undefined;
    this.workOrderId = operation.workOrderId || undefined;
    this.workOrderUpisId = operation.workOrderUpisId || undefined;
    this.client = operation.client || undefined;
    this.isSelected = operation.isSelected || false;
    this.shifts = [
      {
        shiftNumber: 'I',
        quantityPlanned: null
      },
      {
        shiftNumber: 'II',
        quantityPlanned: null
      },
      {
        shiftNumber: 'III',
        quantityPlanned: null
      }
    ];
    this.workOrderClient = operation.workOrderClient || undefined;
    this.upisId = operation.upisId || undefined;
    this.operationName = operation.operationName || undefined;
    this.timeConsumedEmployee = operation.timeConsumedEmployee || 0;
    this.worksheetComments = operation.worksheetComments || undefined;
    this.isButtonVisible = operation.isButtonVisible || true;
    this.form = operation.form || undefined;
    this.isExpanded = operation.isExpanded || undefined;
    this.isFinished = operation.isFinished || undefined;
    this.isPriority = operation.isPriority || undefined;
    this.isExternalOperation = operation.isExternalOperation || false;
    this.operationSupplier = operation.operationSupplier || undefined;
    this.requiredMainTime = operation.requiredMainTime || 0;
    this.requiredAditionalTime = operation.requiredAditionalTime || 0;
    this.isAdded = operation.isAdded || undefined;
    this.productName = operation.productName || undefined;
    this.estimatedCountSesonalWorkersDaily = operation.estimatedCountSesonalWorkersDaily || 0;
    this.timePlannedMachine = operation.timePlannedMachine || 0;
    this.timeConsumedMachine = operation.timeConsumedMachine || 0;
  }
}
